export enum SynchronisationState {
    NotStarted = "NotStarted",
    Running = "Running",
    CompletedOk = "CompletedOk",
    CompletedWithErrors = "CompletedWithErrors",
}
